const dictPermissionsModuleMovimientos: { [key: string]: any } = Object.freeze({
  module_movimientos: 902,
});

export const listPermissionsModuleMovimientos = Object.keys(
  dictPermissionsModuleMovimientos
).map((key: string) => dictPermissionsModuleMovimientos[key]);
